import { CalculateWinner } from './MiscGameFunctions';

function ProcessMove(squareNumber, history, setHistory, stepNumber, setStepNumber, xIsNext, setXIsNext) { 
    let newXIsNext = false;      
    history = (history.slice(0, stepNumber + 1));   // add new move to array - if a new move is made remove future history entries
    const current = history[history.length - 1];    // current move is last one in array
    let newSquares = current.squares.slice();       // create a copy of the array to modify so we can still see previous moves
    if (CalculateWinner(newSquares) || newSquares[squareNumber]) { // if someone has won or the square filled ignore click
      return;
    }
    newSquares[squareNumber] = xIsNext ? 'X' : 'O';  // fill the clicked square with X or O

    let newHistory = history.concat([{   // concat will not mutate the original array
      squares: newSquares                // copy new game board to new history
    }]);

    let newStepNumber = newHistory.length - 1;
    if (xIsNext) {
      newXIsNext = false;
    } else {
      newXIsNext = true;
    }
    setStepNumber(newStepNumber);
    setXIsNext(newXIsNext);
    setHistory(newHistory);
  }; 

  export default ProcessMove;